import classNames from 'classnames';
import React from 'react';

type Props = {
    /**
     * @default false
     */
    leftAlign?: boolean;
    // @default true
    isInModal?: boolean;
} & React.PropsWithRef<JSX.IntrinsicElements['div']>;

const TransactionSubmitWrapper: React.FC<Props> = ({
    leftAlign = false,
    isInModal = true,
    className,
    children,
    ...rest
}) => (
    <div
        className={classNames('transaction-form__submit', className, {
            'left-align': leftAlign,
            'not-in-modal': !isInModal,
        })}
        {...rest}
    >
        {children}
    </div>
);

export default TransactionSubmitWrapper;
